<template>
<div class="after-sale-list list-common">
  <!-- 筛选条件 -->
  <div class="query-div">
    <!-- 已选条件 -->
    <div class="selected-div flex-between">
      <div class="title text-red">售后申请</div>
    </div>
    <div class="mt40">
      <el-steps class="mb30" :active="stepIndex" finish-status="success" align-center>
        <el-step title="提交申请"></el-step>
        <el-step title="客服受理"></el-step>
        <el-step v-if="typeIndex !== 3" title="寄回退货"></el-step>
        <el-step v-if="typeIndex !== 3" title="官方收货"></el-step>
        <el-step :title="typeIndex === 1 ? '完成换货':'完成退款'"></el-step>
      </el-steps>
      <div v-if="stepIndex === 0 && !aftersalesId">
        <p class="sub-title">请选择{{ titleText }}商品</p>
        <el-table :data="itemList" row-key="orderNo" ref="multipleTable"
        style="border-radius:5px; width: 100%; border: 1px solid rgba(143, 168, 188, 0.5)"
        :header-cell-style="{background:'#9B232A',color:'#fff', fontSize: '16px'}"
        @selection-change="handleSelectionChange">
          <el-table-column type="selection" align="center" width="70" :selectable='checkboxSelect' />
          <el-table-column prop="skuName" label="产品名称" align="center" />
          <el-table-column prop="unitPrice" label="产品单价" align="center" />
          <el-table-column label="数量" align="center">
            <template slot-scope="scope">
              <el-input-number v-model="scope.row.refundQuantity" :min="0" :max="scope.row.quantity" @change="handleChangeQuantity(scope.row)"/>
            </template>
          </el-table-column>
          <el-table-column prop="refundAmount" label="金额" align="center" />
        </el-table>
        <div class="mt40 reson-info">
          <div class="mt20 flex">
            <span class="lable">{{ titleText }}数量:</span>
            <span class="w368px">{{ totalQuantity }}</span>
          </div>
          <div class="mt20 flex" v-if="typeIndex !== 1">
            <span class="lable required">{{ titleText }}金额:</span>
            <el-input class="w368px text-org" v-model="refundAmount" :disabled="allUnShipped" :placeholder="`最多￥${totalAmount}`" type="digit" @input="handleInput" />
          </div>
          <div class="mt20 flex">
            <span class="lable required">{{ titleText }}原因:</span>
            <el-select class="w368px" v-model="reason" :placeholder="'请选择' + titleText + '原因'">
              <el-option
              v-for="item in reasonList"
              :key="item"
              :label="item"
              :value="item" />
            </el-select>
          </div>
          <div class="mt20 flex" style="position: relative">
            <span class="lable required">{{ titleText }}原因:</span>
            <el-input class="w679px" type="textarea" :rows="4" maxlength="200" placeholder="为尽快处理您的售后申请，请填写详细描述(10-200字)" v-model="memo" />
            <span class="memoLen">{{ memo.length || 0 }}/200</span>
          </div>
          <div class="mt20 flex">
            <span class="lable">上传图片:</span>
            <el-upload
            class="image-uploader"
            :class="{hide:hideUpload}"
            action
            :http-request="handleSubmitImg"
            :before-upload="beforeAvatarUpload"
            :on-remove="handleRemove"
            :on-change="handleChangeUpload"
            :limit="limitCount"
            :file-list="fileList"
            list-type="picture-card"
            :on-preview="handlePictureCardPreview">
              <span class="flex-column-center">
                <img class="mt20" src="../../assets/images/add.png" alt="">
                <span class="upload-text">上传凭证<br>（最多三张）</span>
              </span>
            </el-upload>
          </div>
          <div class="mt20 flex">
            <span class="lable"></span>
            <el-button class="red-block" :disabled="disableBtn" @click="handleSubmit">提交</el-button>
          </div>
        </div>
      </div>
      <div v-else>
        <div style="width: 1000px; margin: 40px auto">
          <div class="flex step-box" v-for="(item, idx) in progress" :key="item.id">
            <div class="step-icon active" :class="{reject: item.rejectReason != null}">
              <i class="icon-dot"></i>
            </div>
            <div class="step-main flex-1 flex-between">
              <div>
                <p class="step-time">{{ item.crtTime }}</p>
                <p class="step-text" :class="{reject: item.rejectReason != null}">{{ item.detail }}</p>
                <p v-if="item.rejectReason != null" class="reject-reason">审核拒绝原因：{{item.rejectReason}}</p>
              </div>
              <el-button v-if="afterSaleInfo.status === 2 && idx === 0" class="red-line" @click="handlebBackOrder">返回我的订单</el-button>
              <el-button v-if="afterSaleInfo.status === 0 && idx === 0" class="red-block" @click="handleUndo(aftersalesId, afterSaleInfo.typeName)">撤销申请</el-button>
              <el-button v-if="afterSaleInfo.status === 1 && !afterSaleInfo.isSendBack && (afterSaleInfo.type === 1 || afterSaleInfo.type === 2) && idx === 1" class="red-line" @click="handleExpress(aftersalesId)">前往填写发货单号</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <el-dialog :visible.sync="dialogVisible" size="tiny">
    <img width="100%" :src="dialogImageUrl" alt="">
  </el-dialog>
  <!-- 撤销申请 -->
  <UndoDialog :visible="undoDialogVisible" @handleCloseDialog="handleCloseDialog" @handleCancerAftersales="handleCancerAftersales" />
  <!-- 填写快递单号 -->
  <ExpressDialog :visible="expressDialogVisible" :shipCorps="shipCorps" @handleCloseDialog="handleCloseDialog" @handleTransitTabs="handleTransitTabs" />
</div>
</template>

<script>
import fetch from '@/utils/fetch'
import UndoDialog from '@/components/UndoDialog'
import ExpressDialog from '@/components/ExpressDialog'
import { loadOrderInfo, loadAftersalesInfo, aftersalesRefund, aftersalesReplacement, aftersalesReturns, loadAftersalesLogList } from '@/api/afterSales'
import { afterSalesMixin } from '@/mixins/afterSalesMixin'
export default {
  name: 'afterSalesApply',
  mixins: [afterSalesMixin],
  components: {
    UndoDialog,
    ExpressDialog
  },
  data () {
    return {
      uniteOrderNo: null,
      aftersalesId: null,
      stepIndex: 0,
      itemList: [], // 订单列表
      multipleSelection: [],
      reasonList: ['尺寸问题', '商品有瑕疵/脏污', '商品质量问题', '与商品描述不符', '颜色不喜欢', '商品不喜欢', '其他'], // 退货原因
      totalQuantity: 0, // 退款数量
      totalAmount: 0, // 退款金额
      refundAmount: 0,
      reason: null,
      memo: '',
      imgList: [],
      fileList: [],
      hideUpload: false,
      limitCount: 3,
      dialogImageUrl: null,
      dialogVisible: false,
      afterSaleInfo: {},
      typeIndex: null,
      titleText: null,
      allUnShipped: true,
      orderStatus: 0,
      disableBtn: true,
      progress: []
    }
  },
  created () {
    this.uniteOrderNo = this.$route.query.uniteOrderNo
    this.orderStatus = this.$route.query.orderStatus
    this.typeIndex = Number(this.$route.query.typeIndex)
    this.aftersalesId = this.$route.query.aftersalesId
    this.$nextTick(() => {
      if (this.aftersalesId) {
        this.loadAftersalesInfo()
        this.loadAftersalesLogList()
      } else {
        switch (this.typeIndex) {
          case 1:
            this.titleText = '换货'
            break
          case 2:
            this.titleText = '退货'
            break
          case 3:
            this.titleText = '退款'
            break
        }
        if (this.uniteOrderNo) {
          this.loadOrderInfo()
        }
        if (this.orderStatus === '7') {
          this.allUnShipped = false
        }
      }
    })
  },
  methods: {
    checkboxSelect (row) {
      // 1 换货  2 退货退款 3 退款
      if (row.operableQuantity === 0 || (this.typeIndex === 3 && !row.isSupportReturns) || (this.typeIndex === 1 && (!row.isShipping || !row.isSupportReplacement))) {
        return false
      } else {
        return true
      }
    },
    // 返回售后列表
    handlebBackOrder () {
      this.$router.push({
        path: 'afterSalesOrderList'
      })
    },
    // 加载订单详情
    loadOrderInfo () {
      const param = {
        afterSaleType: this.typeIndex, // 1 换货  2 退货退款 3 退款
        uniteOrderNo: this.uniteOrderNo
      }
      loadOrderInfo(param).then(res => {
        if (res.code === 0) {
          this.freight = res.data.freight
          this.itemList = res.data.itemList.map(item => {
            item.refundQuantity = item.quantity
            item.refundAmount = item.refundableAmount
            return item
          })
          let num = 0
          // 1 换货  2 退货退款 3 退款
          res.data.itemList.forEach(item => {
            if (item.operableQuantity === 0 || (this.typeIndex === 3 && !item.isSupportReturns) || (this.typeIndex === 1 && (!item.isShipping || !item.isSupportReplacement))) {
              num += 1
            }
          })
          if (num === res.data.itemList.length || ((this.orderStatus !== '6' || (this.orderStatus === '6' && this.typeIndex !== 3)) && (this.totalQuantity === 0 || this.refundAmount > Number(this.totalAmount)))) {
            this.disableBtn = true
          } else {
            this.disableBtn = false
          }
        }
      })
    },
    // 加载售后详情
    loadAftersalesInfo () {
      loadAftersalesInfo(this.aftersalesId).then(res => {
        if (res.code === 0) {
          this.afterSaleInfo = res.data
        }
      })
    },
    // 查询进度
    loadAftersalesLogList () {
      loadAftersalesLogList(this.aftersalesId).then(res => {
        if (res.code === 0) {
          this.progress = res.data
          if (this.progress.length === 1 || (this.progress.length === 2 && this.progress[1].detail === '已取消')) {
            this.stepIndex = 1
          } else if ((this.progress.length === 2 && this.progress[1].detail !== '已取消') || (this.progress.length === 3 && this.progress[2].detail === '退款处理中')) {
            this.stepIndex = 2
          } else if (this.progress.length === 3) {
            this.stepIndex = 3
          } else if (this.progress.length === 4) {
            this.stepIndex = 4
          } else if (this.progress.length === 5) {
            this.stepIndex = 5
          }
        }
      })
    },
    // 选择退款的产品
    handleSelectionChange (val) {
      this.multipleSelection = val
      this.totalQuantity = 0
      this.totalAmount = 0
      this.multipleSelection.map(item => {
        if (item.isShipping) {
          this.allUnShipped = false
        }
        this.totalQuantity += item.refundQuantity // operableQuantity
        this.totalAmount += item.unitPrice * item.refundQuantity // refundableAmount
      })
      if (this.typeIndex === 3 && this.allUnShipped) {
        // 未发货前的仅退款需退运费
        this.totalAmount += this.freight
      }
      this.refundAmount = this.totalAmount
      let num = 0
      this.multipleSelection.forEach(item => {
        if (item.operableQuantity === 0 || (this.typeIndex === 3 && !item.isSupportReturns) || (this.typeIndex === 1 && (!item.isShipping || !item.isSupportReplacement))) {
          num += 1
        }
      })
      if (num === this.multipleSelection.length || ((this.orderStatus !== '6' || (this.orderStatus === '6' && this.typeIndex !== 3)) && (this.totalQuantity === 0 || this.refundAmount > Number(this.totalAmount)))) {
        this.disableBtn = true
      } else {
        this.disableBtn = false
      }
    },
    // 选择退款数量
    handleChangeQuantity (record) {
      this.handleSelectionChange(this.multipleSelection)
      record.refundAmount = record.refundQuantity * record.unitPrice
      return record
    },
    // 输入退款金额
    handleInput () {
      if (this.refundAmount > Number(this.totalAmount)) {
        this.$message.error('退款金额不得大于' + this.totalAmount)
      }
    },
    // 删除图片
    handleRemove (file, fileList) {
      this.fileList = fileList
      const imgList = []
      this.imgList.forEach(item => {
        if (file.url.indexOf(item) < 0) {
          imgList.push(item)
        }
      })
      this.imgList = imgList
      this.hideUpload = fileList.length >= this.limitCount
    },
    // 修改图片
    handleChangeUpload (file, fileList) {
      this.hideUpload = fileList.length >= this.limitCount
    },
    // 预览图片
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    // 图片上传前校验
    beforeAvatarUpload (file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/gif'
      const isLt10M = file.size / 1024 / 1024 < 1
      if (!isJPG) {
        this.$message.error('请上传jpg,jpeg,png或者gif格式的图片!')
      }
      if (!isLt10M) {
        this.$message.error('上传大小不能超过 1MB!')
      }
      return isJPG && isLt10M
    },
    // 上传图片
    handleSubmitImg (arg) {
      const formData = new FormData()
      formData.append('file', arg.file)
      formData.append('isOpen', 'T')
      fetch({
        url: '/oss/endpoint/put-img',
        method: 'post',
        data: formData
      })
        .then(res => {
          if (res.code === 0) {
            this.fileList.push({
              name: res.data.name,
              url: res.data.link
            })
            this.imgList.push(res.data.link)
            this.$message.success('上传成功')
          } else {
            this.$message.error(res.error)
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    // 提交售后申请
    handleSubmit () {
      if (!this.reason || this.reason.trim() === '') {
        this.$message.error('请选择' + this.titleText + '原因')
        return
      }
      if (!this.memo) {
        this.$message.error('请输入' + this.titleText + '原因')
        return
      }
      if (this.memo.length < 10) {
        this.$message.error('请输入不少于10字退款说明')
        return
      }
      const aftersalesItems = []
      const list = this.multipleSelection.filter(item => item.refundQuantity > 0)
      if (list.length === 0) {
        this.$message.error('请选择' + this.titleText + '商品数量')
        return
      }
      if (this.flag) {
        return
      }
      this.flag = true
      list.forEach(item => {
        aftersalesItems.push({
          orderNo: item.orderNo,
          quantity: item.refundQuantity
        })
      })
      let refundAmount = this.totalAmount
      if (!this.allUnShipped) {
        refundAmount = this.refundAmount == null ? this.totalAmount : this.refundAmount
      }
      const param = {
        aftersalesItems,
        uniteOrderNo: this.uniteOrderNo,
        refundAmount,
        reason: this.reason,
        memo: this.memo
      }
      if (this.imgList && this.imgList.length > 0) {
        param.image = this.imgList
      }
      // 换货
      if (this.typeIndex === 1) {
        delete param.refundAmount
        param.isPatchOrderReceiver = true
        this.aftersalesReplacement(param)
      }
      // 退货申请
      if (this.typeIndex === 2) {
        this.aftersalesReturns(param)
      }
      // 退款申请
      if (this.typeIndex === 3) {
        // 发货前仅退款不需要传 aftersalesItems ，发货后仅退款，运费不可退
        // if (this.allUnShipped && this.orderStatus !== '7') {
        //   delete param.aftersalesItems
        // }
        this.aftersalesRefund(param)
      }
    },
    // 退款申请
    aftersalesRefund (param) {
      aftersalesRefund(param).then(res => {
        if (res.code === 0) {
          this.$message({
            message: '已提交退款申请',
            type: 'success'
          })
          this.aftersalesId = res.data.id
          this.loadAftersalesInfo()
          this.loadAftersalesLogList()
        } else {
          this.$message.error(res.error)
        }
        this.flag = false
      })
    },
    // 换货申请
    aftersalesReplacement (param) {
      aftersalesReplacement(param).then(res => {
        if (res.code === 0) {
          this.$message({
            message: '已提交换货申请',
            type: 'success'
          })
          this.aftersalesId = res.data
          this.loadAftersalesInfo()
          this.loadAftersalesLogList()
        } else {
          this.$message.error(res.error)
        }
        this.flag = false
      })
    },
    // 退货申请
    aftersalesReturns (param) {
      aftersalesReturns(param).then(res => {
        if (res.code === 0) {
          this.$message({
            message: '已提交退货申请',
            type: 'success'
          })
          if (typeof res.data === 'object') {
            this.aftersalesId = res.data.id
          } else {
            this.aftersalesId = res.data
          }
          this.loadAftersalesInfo()
          this.loadAftersalesLogList()
        } else {
          this.$message.error(res.error)
        }
        this.flag = false
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/common/css/afterSales.scss';
/deep/.el-step__icon{
  width: 36px;
  height: 36px;
  font-size: 18px;
}
/deep/.el-step.is-horizontal .el-step__line{
  top: 16px;
}
/deep/.el-step__title.is-process{
  color: #242B34
}
/deep/.el-step__head.is-process{
  .el-step__icon.is-text{
    border-color: #74C148;
    background: #74C148;
    color: #fff;
  }
}
/deep/.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
  background-color: #FC600C;
  border-color: #FC600C;
}
.memoLen{
  position: absolute;
  left: 740px;
  bottom: 10px;
  font-size: 12px;
  color: #9FA1B0;
}
/deep/.el-table__header .has-gutter tr .el-table-column--selection .cell .el-checkbox:after {
  content: " 全选";
  color: #fff;

}
</style>
